import React from "react";

import { format } from "date-fns";

import { FaDownload } from "react-icons/fa";

import { Flex, Spacer, Text, Icon, Link } from "@chakra-ui/react";

import { API } from "../../../../../main/config";

const SubListItem = ({ nome, data, id, path }) => {
  return (
    <Flex
      id={nome}
      bgColor="#E3E3E3"
      h={{ base: "auto", lg: "40px" }}
      mt="10px"
      ml={{ base: "15px", lg: "30px" }}
      px={{ base: "15px", lg: "25px" }}
      py={{ base: "5px", lg: "10px" }}
      alignItems="center"
    >
      <Flex
        flexDir={{ base: "column", lg: "row" }}
        h="100%"
        flex="1"
        alignItems={{ base: "flex-start", lg: "center" }}
      >
        <Text
          color="#1A203D"
          fontWeight="400"
          fontSize="14px"
          lineHeight={{ base: "19.6px", lg: "21.6px" }}
        >
          {nome}
        </Text>
        <Spacer display={{ base: "none", lg: "block" }} />
        <Text
          color="#797A80"
          fontWeight="700"
          fontSize="12px"
          lineHeight="15px"
          mr={{ base: "0px", lg: "10px" }}
        >
          Data do Documento: {data ? format(data, "dd/MM/yyyy") : ""}
        </Text>
      </Flex>
      <Link
        href={
          path.toString().includes(".png") ||
          path.toString().includes(".jpg") ||
          path.toString().includes(".jpeg") ||
          path.toString().includes(".pdf")
            ? API + `/anexos/${id}/visualizar`
            : API + `/anexos/${id}/download`
        }
        target="_blank"
      >
        <Icon
          aria-label="Download"
          color="#006064"
          as={FaDownload}
          boxSize="20px"
          _hover={{ cursor: "pointer" }}
        />
      </Link>
    </Flex>
  );
};

export default SubListItem;
